import { EIconNames } from "src/shared/types/iconNames";
import { ToolKey, ServiceId } from "../types/types";

export const tools = [
  { key: "reco", label: "Рекомендации" },
  { key: "advisor", label: "Советник" },
  { key: "reportlab", label: "ReportLab" },
  { key: "utm", label: "UTM\nПомощник" },
  { key: "flows", label: "Потоки" },
  { key: "automation", label: "Центр\nАвтоматизации" },
] as const;

export const services = [
  { id: "google", name: "Google ADS", icon: EIconNames.GOOGLE_ADS_ST },
  { id: "tiktok", name: "TikTok", icon: EIconNames.TIKTOK_ST },
  { id: "vkads", name: "VK Реклама", icon: EIconNames.VK_ADS_ST },
  { id: "fb", name: "Meta", icon: EIconNames.META_ST },
  { id: "yandex", name: "Yandex Direct", icon: EIconNames.YANDEX_DIRECT_ST },
] as const;

export const TOOL_NAME_TO_KEY: Record<string, ToolKey> = {
  recommendations: "reco",
  adviser: "advisor",
  reportlab: "reportlab",
  utm_assistant: "utm",
  adflow: "flows",
  automation_center: "automation",
};

export const serviceTabsOptions = services.map((s) => ({
  name: s.name,
  value: s.id,
  label: s.name,
  iconName: s.icon,
}));

export const serviceIds = services.map((s) => s.id) as readonly ServiceId[];

export const EDIT_PERMS = ["crm:access:servicetools:edit"];
